//#region IMPORTS
import {
  basketReasonSelectors,
  fetchBasketReasonsAsync,
} from "../basketReason/basketReasonSlice";
import { removeBasketItemAsync, addBasketItemAsync } from "./basketSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Item } from "../../models/item";
import Trashcan from "../../components/icons/Trashcan";
//#endregion

//#region INTERFACE
interface Props {
  item: Item;
}
//#endregion

export default function BasketPageItem({ item }: Props) {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Redux
  const dispatch = useAppDispatch();
  const { status } = useAppSelector((state) => state.basket);
  const basketReasons = useAppSelector(basketReasonSelectors.selectAll);
  const { basketReasonsLoaded } = useAppSelector(
    (state) => state.basketReasons
  );

  // Local state
  const [reasonId, setReasonId] = useState<number>();
  //#endregion

  //#region LOGIC
  // Fetch basket reasons
  useEffect(() => {
    !basketReasonsLoaded && dispatch(fetchBasketReasonsAsync());
  }, [basketReasonsLoaded, dispatch]);

  // Set item reason id
  useEffect(() => {
    const itemReason = basketReasons.find(
      (reason) => reason.reason === item.basket_reason
    );
    itemReason && setReasonId(itemReason.id);
  }, [basketReasons, item]);
  //#endregion

  //#region RENDER
  return (
    <div
      className="grid grid-cols-[0_2fr_50px_80px] md:grid-cols-[100px_2fr_50px_80px] lg:grid-cols-[150px_2fr_100px_80px] xl:grid-cols-[350px_2fr_200px_80px] gap-4 p-2 text-left border-t border-b border-black even:bg-[#f2f2f2]"
      key={item.product_version_id}
    >
      <div className="hidden md:flex items-center justify-center">
        <img
          src={item.picture_url}
          className="block max-h-[60px] max-w-[120px] xl:max-h-[100px] xl:max-w-[300px]"
          alt="pending"
        />
      </div>

      <div className="flex flex-col justify-center text-base pr-4">
        <p>{item.name}</p>
        {item.basket_reason && (
          <p className="text-[#254559] text-sm">
            {t("rituals.reason")}:{" "}
            <b>{t(`rituals.${item.basket_reason.toLocaleLowerCase()}`)}</b>
          </p>
        )}
      </div>

      <div className="grid grid-cols-[1fr_2fr_1fr] items-center">
        <button
          className="block min-w-[2rem] font-bold text-3xl text-[#254559]"
          onClick={() =>
            dispatch(
              removeBasketItemAsync({
                product_version_id: item.product_version_id,
                quantity: 1,
                promo_id: item.promo_id,
                name: "remove",
              })
            )
          }
        >
          -
        </button>

        <p className="text-center text-2xl">{item.quantity}</p>

        <div>
          {item.quantity < item.max_quantity && (
            <button
              className="block min-w-[2rem] font-bold text-3xl text-[#254559]"
              onClick={() =>
                !status.includes("PendingAddItem") &&
                dispatch(
                  addBasketItemAsync({
                    product_version_id: item.product_version_id,
                    promo_id: item.promo_id,
                    max_quantity: item.max_quantity,
                    quantity: 1,
                    basket_reason_id: reasonId,
                  })
                )
              }
            >
              +
            </button>
          )}
        </div>
      </div>

      <button
        className="flex items-center justify-center p-4"
        onClick={() =>
          dispatch(
            removeBasketItemAsync({
              product_version_id: item.product_version_id,
              quantity: item.quantity,
              promo_id: item.promo_id,
              name: "del",
            })
          )
        }
      >
        <Trashcan color="#f25c5c" width={24} />
      </button>
    </div>
  );
  //#endregion
}
